
// Events
export const AT_RETIREMENT_APPLICATION_SET_VALUE = 'atRetirement/atRetirementApplication/setValue/';
export const SET_REFERRER_ID = AT_RETIREMENT_APPLICATION_SET_VALUE + 'referrerId';

export const setReferrerId = value => ({ type: SET_REFERRER_ID, value });